import React from 'react';
import { useLocation } from 'react-router-dom';
import EmailBuilder from './EmailBuilder';
import BlockEmailBuilder from './BlockEmailBuilder';

// New templates use the block builder; templates made with the legacy row/column builder
// (structure is an array of rows) keep opening in it.
const TemplateBuilder = () => {
  const location = useLocation();
  const structure = location.state?.template?.structure;
  return Array.isArray(structure) ? <EmailBuilder /> : <BlockEmailBuilder key={location.key} />;
};

export default TemplateBuilder;
